<div class="cookie-consent-wrap" *ngIf="!isConsentGiven">
    <div class="cookie-consent">
        <div class="close-wrap">
            <div class="close-icon" (click)='closeCookieConsent()'>
                <ua-close-icon></ua-close-icon>
            </div>
        </div>
        <div class="content">
            <div class="content-text">
                <span>
                    {{ pageConstants.cookieText }}
                    <!-- United uses cookies to personalize and improve
                    your website experience. By using Agent on
                    Demand, you agree to the use of cookies as 
                    described in our -->
                    <a [href]="cookiePolicy" target="_blank"><u>{{ pageConstants.cookiePolicy }}</u></a>.
                </span>
            </div>
            
        </div>
    </div>
</div>